import gql from 'graphql-tag'

export const SEND_CONTRACT_TERMINATION_AGAIN = gql`
    mutation SendContractTerminationMailAgain($input: ContractTerminationInput!) {
        sendContractTerminationMailAgain(input: $input)
    }
`
